// 兼容判断
export const supported = {
  performance: !!window.performance,
  getEntriesByType: !!(window.performance && performance.getEntriesByType),
  PerformanceObserver: "PerformanceObserver" in window,
  MutationObserver: "MutationObserver" in window,
  PerformanceNavigationTiming: "PerformanceNavigationTiming" in window,
};

/**
 * 格式化性能记录
 */
export function normalizePerformanceRecord(e) {
  Object.keys(e).forEach((p) => {
    const v = e[p];
    if (typeof v === "number") {
      if (v > 0) {
        e[p] = parseFloat((v / 1000).toFixed(2));
      } else {
        e[p] = 0;
      }
    }
  });
  return e;
}

/**
 * 发送首次页面性能数据
 */
export function observeNavigationTiming() {
  const times = {};
  const performance =
    window.performance ||
    window.msPerformance ||
    window.webkitPerformance;
  let t = performance.timing;

  if (!performance) return false;

  times.fmp = 0;
  if (supported.getEntriesByType) {
    const paintEntries = performance.getEntriesByType("paint");
    if (paintEntries.length)
      times.fmp = paintEntries[paintEntries.length - 1].startTime;
    if (supported.PerformanceNavigationTiming) {
      const nt2Timing = performance.getEntriesByType("navigation")[0];
      if (nt2Timing) {
        // @ts-ignore
        t = nt2Timing;
      }
    }
  }

  if (times.fmp && supported.PerformanceNavigationTiming)
    times.fmp -= t.fetchStart;

  times.tti = t.domInteractive - t.fetchStart; // 首次可交互时间
  times.ready = t.domContentLoadedEventEnd - t.fetchStart; // HTML加载完成时间
  times.loadon = t.loadEventStart - t.fetchStart; // 页面完全加载时间
  times.firstbyte = t.responseStart - t.domainLookupStart; // 首包时间
  times.dns = t.domainLookupEnd - t.domainLookupStart; // dns查询耗时
  times.appcache = t.domainLookupStart - t.fetchStart; // dns缓存时间
  times.tcp = t.connectEnd - t.connectStart; // tcp连接耗时
  times.ttfb = t.responseStart - t.requestStart; // 请求响应耗时
  times.trans = t.responseEnd - t.responseStart; // 内容传输耗时
  times.dom = t.domInteractive - t.responseEnd; // dom解析耗时
  times.res = t.loadEventStart - t.domContentLoadedEventEnd; // 同步资源加载耗时
  times.ssllink = t.connectEnd - t.secureConnectionStart; // SSL安全连接耗时
  times.redirect = t.redirectEnd - t.redirectStart; // 重定向时间
  times.unloadTime = t.unloadEventEnd - t.unloadEventStart; // 上一个页面的卸载耗时

  const event = normalizePerformanceRecord({
    ...times,
    pageUrl: window.location.host,
  });
  window.dzBeacon.onUserAction("initPage_performance", event);
}

/**
 * 初始化执行
 */
export function performanceInit() {
  // 初始化方法可能在onload事件之后才执行,此时不会触发load事件了,检查document.readyState属性来判断onload事件是否会被触发
  if (document.readyState === "complete") {
    if (supported.performance) observeNavigationTiming();
  } else {
    window.addEventListener("load", () => {
      if (supported.performance) observeNavigationTiming();
    });
  }
}